<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import "./components/font/font.css";
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
 
.router-link-active {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue